import React, {useState, useEffect, useRef} from 'react'
import DataView from '../../../../UI/Dashboard/DataView'
import Ajax from '../../../../../helpers/Ajax'
import { useParams, useNavigate } from 'react-router-dom'
import FormGroup from '../../../../UI/Form/FormGroup'
import ErrorField from '../../../../UI/Form/ErrorField'
import { Formik, Field, Form, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import DataLoader from '../../../../UI/Dashboard/DataLoader'
import Button from '../../../../UI/Form/Button'
import ContentLayout from '../../../../Common/ContentLayout'
import { toast } from 'react-toastify'
import { Helmet } from 'react-helmet-async'
import UploadFile from '../../../../../helpers/UploadFile'
export default function AddNewAmenity() {
    const [mobileImage, setMobileImage] = useState("")
    const urlParams = useParams()
    const navigate = useNavigate()

    const dataIcon = useRef()
    const addProcess = async (values, event) => {
        if(dataIcon.current.value === ''){
            toast.error('Icon is Required',{
                toastId: 'iconRequired'
            })
            return false
        }

        const formData = new FormData()
        if(dataIcon.current.value != ''){
            formData.append("file", dataIcon.current.files[0])
        }

        const data = {
            name: values.amenity_title, 
            active: values.active == 1 ? true : false, 
            mobileFile: mobileImage
        }
        for(var key in data) {
            if(data[key] !== "") {
                formData.append(key, data[key])
            }
        }
        const update = await Ajax({
            url: `/amenities`,
            method: 'POST',
            token: true,
            data: formData,
            loader: true
        })
        if(update.data.error){
            toast.error('Something Went Wrong Please Check')
        }
        if(update.data.status === "SUCCESS!"){
            toast.success('Amenity Added Successfully')
            setTimeout(function(){
                navigate('/admin/property-management/amenities')
            },500)
        }
    }

    async function uploadImage(e){
        const imageUrl = await UploadFile(e)
        setMobileImage(imageUrl)
    }

    return (
        <ContentLayout title="Add New Amenity">
            <Helmet>
                <title>Add New Amenity</title>
            </Helmet>
            <DataView title="Infomation">
                <Formik
                    initialValues={{ 
                        amenity_title: '', 
                        active: '1',
                    }}
                    validationSchema={Yup.object({
                        amenity_title: Yup.string()
                        .required('Field is Required'),
                        active: Yup.string()
                        .required('Field is Required')
                    })}
                    onSubmit={(values, event) => {
                        addProcess(values, event)
                    }}
                >
                <Form>
                    <div className='row'>
                        <div className='col-md-8'>
                            <FormGroup label="Amenity Title" required>
                                <Field placeholder='Amenity Title' name="amenity_title" className='form-control' />
                                <ErrorField><ErrorMessage name="amenity_title"/></ErrorField>
                            </FormGroup>
                        </div>
                        <div className='col-md-4'>
                            <FormGroup label="Amenity Icon" required>
                                <input type="file" accept='.jpg, .png, jpeg, .webp' name="amenity_image" ref={dataIcon} className='form-control' />
                            </FormGroup>
                        </div>
                         <div className='col-md-6'>
                            <FormGroup label="Amenity Mobile Image">
                                 <input type="file" name="mobileFile" className='form-control' onChange={uploadImage}/>
                            </FormGroup>
                        </div>
                        <div className='col-md-6'>
                            {mobileImage && 
                            <FormGroup label="Preview">
                                <img src={mobileImage} alt="prcess icon" width="80px" className='img-fluid' /> 
                            </FormGroup>}
                        </div>
                    </div>
                    <FormGroup label="Active" required>
                        <Field as="select" name="active" className='form-select'>
                            <option value="1">Enable</option>
                            <option value="2">Disable</option>
                        </Field>
                        <ErrorField><ErrorMessage name="type"/></ErrorField>
                    </FormGroup>
                    <div className='col-md-2 d-grid'>
                        <Button type="submit">Add</Button>
                    </div>
                </Form>
                </Formik>
            </DataView>
        </ContentLayout>
    )
}
